<template>
  <FitToast
    v-show="loading.show"
    :icon="loading.type"
    class="fit-font-30"
    :showDotLine="showDotLine"
  >
    <span>{{ loading.title }}</span>
  </FitToast>
</template>
<script lang="ts">
import { FitIcon, FitToast } from '@tencent/wphk-ui';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { LoadingType } from './business/business';
import store from './business/store';

@Component({
  components: {
    FitIcon,
    FitToast,
  },
})
export default class FitLoading extends Vue {
  get showDotLine() {
    return !!((this.loading.type === LoadingType.Security || this.loading.type === LoadingType.WechatPay));
  }
  public loading = store.loading;
  @Prop({ default: 'loading' }) public type!: string;
}
</script>
